import BaseFunc from '../basefunc'

export class CollectionPageSensor extends BaseFunc {
  private static getCollectionID(): string {
    return (
      window
        .atob(
          (
            this.getMain().getElementsByClassName(
              'collection'
            )[0] as HTMLElement
          ).dataset.id ?? ''
        )
        .replace(/\D/g, '') ?? ''
    )
  }

  private static getCollectionName(): string {
    return (
      (this.getMain().getElementsByClassName('collection')[0] as HTMLElement)
        .dataset.name ?? ''
    )
  }

  // eslint-disable-next-line class-methods-use-this
  public getCollectionID2(oID: string): string {
    return window.atob(oID).replace(/\D/g, '')
  }

  private CollectionShow(): void {
    const data = {
      collection_id: CollectionPageSensor.getCollectionID(),
      collection_name: CollectionPageSensor.getCollectionName(),
    }
    this.getSensors().track('CollectionShow', data)
  }

  public SortMethodClick(sortMethod: string): void {
    const data = {
      collection_id: CollectionPageSensor.getCollectionID(),
      collection_name: CollectionPageSensor.getCollectionName(),
      sort_method: sortMethod,
    }
    this.getSensors().track('SortMethodClick', data)
  }

  public CollectionTurnPage(turnType: Number): void {
    const data = {
      collection_id: CollectionPageSensor.getCollectionID(),
      collection_name: CollectionPageSensor.getCollectionName(),
      turn_page_type: turnType,
    }
    this.getSensors().track('CollectionTurnPage', data)
  }

  public CollectionLeave(): void {
    const data = {
      collection_id: CollectionPageSensor.getCollectionID(),
      collection_name: CollectionPageSensor.getCollectionName(),
      product_number: BaseFunc.visited_product.length,
      stay_time: this.getStayTime(),
    }
    this.getSensors().track('CollectionLeave', data)
  }

  public Action(): void {
    this.CollectionShow()
  }
}

const isServer = !process.browser
let collectionPageSensor = null
export default (() => {
  if (!isServer) {
    collectionPageSensor = new CollectionPageSensor()
  }
  return collectionPageSensor
})()
